export function encryptStringWithXORtoHex(input,key) {
  var output = [];
  var charCode;
  for (var i = 0; i < input.length; i++) {
    charCode = input.charCodeAt(i) ^ key[i % key.length].charCodeAt(0);
    output.push(String.fromCharCode(charCode));
  }
  return output.join("");
}
